<template>
  <div class="wrapper">
    <div
      v-for="(item, index) in allItems"
      :key="item.id"
      class="wrapper-description"
    >
      <div
        class="wrapper-description_unactive"
        v-if="index !== activeIndexMain || currentWidth < 768"
        :class="[`wrapper-description_unactive-${index}`]"
        @click="changeMainIndex(index)"
      >
        <div
          class="unactive_title"
          v-if="currentWidth >= 768 && item.name"
        >
          <span>{{ $t(item.name) }}</span>
        </div>
        <img :src="item.content[0].images[0]" alt="altImageDefault"/>
      </div>
      <div
        class="wrapper-description_active"
        v-if="index === activeIndexMain"
      >
        <div
          class="content__count-items"
          v-if="activeTypeItems !== 'tour' && isMount"
        >
          <div
            v-for="(item, index2) in activeItemSlide"
            class="content__count-img"
            @click="chooseItemActive(item, index2)"
            :class="{
              'content__count-img_active': index2 === choosenItem,
            }"
          ></div>
        </div>
        <div class="content__description" ref="descriptionRef">
          <div class="description__wrapper">
            <div class="type-btns">
              <SvgOfferPhotoSvg
                v-if="activeItemDesc?.images?.length"
                bg-color="#FFFFFF"
                :opacity="activeTypeItems === 'images' ? 1 : 0.1"
                @click="chooseActiveTypeItemsHandler('images')"
                :color="IconsColorStyle('images')"
              />
              <SvgOfferVideoSvg
                v-if="activeItemDesc?.video?.length"
                bg-color="#FFFFFF"
                :opacity="activeTypeItems === 'video' ? 1 : 0.1"
                @click="chooseActiveTypeItemsHandler('video')"
                :color="IconsColorStyle('video')"
              />
              <SvgOfferTourSvg
                v-if="activeItemDesc?.tour"
                bg-color="#FFFFFF"
                :opacity="activeTypeItems === 'tour' ? 1 : 0.1"
                :color="IconsColorStyle('tour')"
                @click="chooseActiveTypeItemsHandler('tour')"
              />
            </div>
            <div class="description">
              <h3>{{ $t(item.name) }}</h3>
              <p>{{ $t(activeItemDesc.description) }}</p>
            </div>
          </div>
          <div class="wrapper-author">
            <UiAuthorSlider
              :authors="allItemDesc"
              :activeItemDesc="activeItemDesc"
              :allItemDesc="allItemDesc"
              @change-author="changeAuthorIndex"
            />
          </div>
        </div>
        <div
          class="carousel"
          @mousemove="dragging"
          @mousedown="dragStart"
          @mouseup="dragStop"
          @mouseleave="dragStop"
          @touchstart="dragStart"
          @touchmove="dragging"
          @touchend="dragStop"
          ref="videoSliderRef"
        >
          <div v-if="activeTypeItems === 'video'" class="video">
            <UiVideoSlider
              :items="activeItemSlide"
              :isMobile="isMobile"
              :isDragging="isDragging"
              :firstImgWidth="firstImgWidth"
              :loadVideoForStart="loadVideoForStart"
              :videoRange="videoRange"
            />
          </div>
          <div
            v-else-if="activeTypeItems === 'images'"
            class="images"
          >
            <UiImageSlider
              :items="activeItemSlide"
              :firstImgWidth="firstImgWidth"
              @full-screen="openInFullSizeHandler"
            />
          </div>
          <div v-else-if="activeTypeItems === 'tour'">
            <UiTourSlider :items="activeItemSlide"/>
          </div>
        </div>
      </div>
    </div>
    <div
      class="wrapper-description_switch-btns"
      v-if="currentWidth < 901"
    >
      <button class="btn-prev" @click.prevent="prevMainIndex">
        <BtnArrow/>
      </button>
      <button class="btn-next" @click.prevent="nextMainIndex">
        <BtnArrow :right="true"/>
      </button>
    </div>
  </div>

  <UiModalsFullScreenModalV2
    v-if="isOpenFullScreenModal"
    :typeItems="activeTypeItems"
    :items="activeItemSlide"
    :posters="posters"
    :item-active="currentIndexFullScreenImg"
    :is-need-additional-block="false"
    @close-action="closeActionHandler"
    bg-color="transparent"
  />
</template>

<script setup lang="ts">
import {ref, computed, watch, type ComputedRef} from 'vue';
import {useBaseStore} from '~/modules/BaseModule/base.store';
import BtnArrow from '~/components/svg/BtnArrow.vue';

const props = withDefaults(
  defineProps<{
    items: any;
  }>(),
  {
    items: [],
  },
);

const allItems = ref(props.items);
const isMount = ref(false);
const activeIndexMain = ref(0);
const allItemDesc = ref(props.items[activeIndexMain.value].content);
const activeItemDesc = ref(
  props.items[activeIndexMain.value].content[0],
);
const activeItemSlide = ref(
  props.items[activeIndexMain.value].content[0].images,
);

type TypeItems = 'images' | 'video' | 'tour';
const activeTypeItems = ref<TypeItems>('images');

const activeAuthorItem = ref<number>(0);
const posters = ref(
  props.items[activeIndexMain.value].content[activeAuthorItem.value]
    .poster,
);
const base = useBaseStore();
const isMobile: ComputedRef<boolean> = computed(() => base.isMobile);
const videoRange = ref<null | number[]>(null);
const loadVideoForStart = ref<{ [key: string]: boolean }>({});
const videoSliderRef = ref<null | HTMLVideoElement[] | HTMLElement[]>();
const descriptionRef = ref(null);
const iconLeft = ref();
const iconRight = ref();
const currentIndexFullScreenImg = ref(0);
const currentHeightUnactiveItem = ref('100%');
const currentHeightBlockWithActiveItem = ref('100%');
const currentWidth = ref(base.currentWidth);

let positionDiff: number;
const firstImgWidth = ref<number>(0);
let isDragStart = false;
let prevPageX: number;
let prevScrollLeft: number;
let scrollWidth: number;
const isDragging = ref<boolean>(false);
const choosenItem = ref<number>(0);
const isOpenFullScreenModal = ref(false);

const changeAuthorIndex = (index: number) => {
  // Сохраняем выбранный вариант просмотра (фото, видео, 3д) при переключении
  // между автороами (кроме момента когда этого варинта нет)
  if (props.items[activeIndexMain.value].content[index][activeTypeItems.value].length == 0)
    activeTypeItems.value = 'images';

  activeAuthorItem.value = index;
  activeItemDesc.value =
    props.items[activeIndexMain.value].content[index];
  console.log();
  activeItemSlide.value =
    props.items[activeIndexMain.value].content[
      activeAuthorItem.value
      ]?.[activeTypeItems.value];
  chooseItemActive(activeItemSlide.value[0], 0);
};

const changeMainIndex = (index: number) => {
  activeIndexMain.value = index;
  activeAuthorItem.value = 0;
  activeItemSlide.value =
    props.items[activeIndexMain.value].content[
      activeAuthorItem.value
      ]?.['video'];
  activeItemDesc.value =
    props.items[activeIndexMain.value].content[0];
  allItemDesc.value = props.items[activeIndexMain.value].content;
  activeTypeItems.value = 'video';
  chooseItemActive(activeItemSlide.value[0], 0);
};

const nextMainIndex = () => {
  activeIndexMain.value < props.items.length - 1
    ? activeIndexMain.value++
    : (activeIndexMain.value = 0);
  activeAuthorItem.value = 0;
  activeItemSlide.value =
    props.items[activeIndexMain.value].content[
      activeAuthorItem.value
      ]?.['images'];
  activeItemDesc.value =
    props.items[activeIndexMain.value].content[0];
  allItemDesc.value = props.items[activeIndexMain.value].content;
  activeTypeItems.value = 'images';
  chooseItemActive(activeItemSlide.value[0], 0);
};

const prevMainIndex = () => {
  activeIndexMain.value > 0
    ? activeIndexMain.value--
    : (activeIndexMain.value = props.items.length - 1);
  activeAuthorItem.value = 0;
  activeItemSlide.value =
    props.items[activeIndexMain.value].content[
      activeAuthorItem.value
      ]?.['images'];
  activeItemDesc.value =
    props.items[activeIndexMain.value].content[0];
  allItemDesc.value = props.items[activeIndexMain.value].content;
  activeTypeItems.value = 'images';
  chooseItemActive(activeItemSlide.value[0], 0);
};

const IconsColorStyle = (typeItems: TypeItems) => {
  return activeTypeItems.value === typeItems
    ? 'var(--var-blue-50)'
    : currentWidth.value < 721
      ? '#64686E'
      : 'var(--var-white-000)';
};

const chooseActiveTypeItemsHandler = (type: TypeItems) => {
  if (!activeItemDesc.value?.video?.length && type === 'video')
    return;
  activeTypeItems.value = type;

  if (type === 'video') {
    activeItemSlide.value =
      props.items[activeIndexMain.value].content[
        activeAuthorItem.value
        ]?.[type];
    chooseItemActive(activeItemSlide.value[0], 0);
    return;
  }
  activeItemSlide.value =
    props.items[activeIndexMain.value].content[
      activeAuthorItem.value
      ]?.[type];
};

const closeActionHandler = () =>
  (isOpenFullScreenModal.value = false);

const openInFullSizeHandler = (index: number) => {
  if (!isDragging.value) {
    currentIndexFullScreenImg.value = index;
    isOpenFullScreenModal.value = true;
  }
};

const showHideIcons = (isNeedChoosenItem?: boolean) => {
  if (videoSliderRef.value) {
    const videoSlider = videoSliderRef.value[0];
    if (!isNeedChoosenItem) {
      choosenItem.value = Math.round(
        videoSlider.scrollLeft / firstImgWidth.value,
      );
    }

    if (iconLeft.value) {
      iconLeft.value.style.display =
        videoSlider.scrollLeft <= 120 ? 'none' : 'block';
    }

    if (iconRight.value) {
      iconRight.value.style.display =
        videoSlider.scrollLeft + 20 >= scrollWidth ? 'none' : 'block';
    }
  }
};

const chooseItemActive = (activeItem: string, index: number) => {
  choosenItem.value = index;
  let choosenItemById: HTMLVideoElement | HTMLImageElement | null;
  setTimeout(() => {
    if (activeTypeItems.value === 'video') {
      choosenItemById = document.getElementById(
        activeItem[0],
      ) as HTMLVideoElement;
      if (choosenItemById) {
        choosenItemById.src = activeItem[0];
        choosenItemById.play();
      }
    } else
      choosenItemById = document.getElementById(
        activeItem,
      ) as HTMLImageElement;

    if (choosenItemById) {
      new Promise((res) => {
        if (videoSliderRef.value && choosenItemById) {
          videoSliderRef.value[0].scrollLeft =
            choosenItemById?.offsetLeft;
        }
        res('');
      }).then(() => {
        setTimeout(() => showHideIcons(true), 1300);
      });
    }
  }, 100);
};

const dragging = (e: MouseEvent | TouchEvent) => {
  if (videoSliderRef.value) {
    if (!isDragStart) return;
    e.preventDefault();
    isDragging.value = true;
    videoSliderRef.value[0].classList.add('dragging');
    positionDiff =
      e instanceof MouseEvent
        ? e.pageX - prevPageX
        : e.touches[0].pageX - prevPageX;
    videoSliderRef.value[0].scrollLeft =
      prevScrollLeft - positionDiff;
  }
};

const autoSlide = () => {
  if (
    activeTypeItems.value === 'video' &&
    videoRange.value?.length !== activeItemSlide.value.length
  ) {
    videoRange.value = Array.from(
      Array(activeItemSlide.value.length).keys(),
    );
  }

  if (!videoSliderRef.value) return;
  const videoSlider = videoSliderRef.value[0];
  if (
    videoSlider.scrollLeft <= 0 ||
    videoSlider.scrollLeft >=
    videoSlider.scrollWidth - videoSlider.clientWidth
  )
    return;

  positionDiff = Math.abs(positionDiff);
  const additionalValueML = isMobile.value ? 10 : 14;
  firstImgWidth.value = videoSlider.clientWidth + additionalValueML;
  let valDifference = firstImgWidth.value - positionDiff;

  if (videoSlider?.scrollLeft > prevScrollLeft) {
    return (videoSlider.scrollLeft +=
      positionDiff > firstImgWidth.value / 5
        ? valDifference
        : -positionDiff);
  }

  return (videoSlider.scrollLeft -=
    positionDiff > firstImgWidth.value / 5
      ? valDifference
      : -positionDiff);
};

const dragStart = (e: MouseEvent | TouchEvent) => {
  if (videoSliderRef.value) {
    isDragStart = true;
    prevPageX =
      e instanceof MouseEvent ? e.pageX : e.touches[0].pageX;
    prevScrollLeft = videoSliderRef.value[0].scrollLeft;
  }
};

const dragStop = (e: MouseEvent | TouchEvent) => {
  isDragStart = false;
  if (videoSliderRef.value && videoSliderRef.value[0]) {
    const videoSlider = videoSliderRef.value[0];
    videoSlider.classList.remove('dragging');
    if (!isDragging.value) return;
    setTimeout(() => (isDragging.value = false), 0);
    new Promise((res, rej) => {
      const afterSlide = autoSlide();
      if (
        videoSliderRef.value &&
        afterSlide &&
        afterSlide % firstImgWidth.value !== 0
      ) {
        videoSlider.scrollLeft =
          firstImgWidth.value *
          Math.round(videoSlider.scrollLeft / firstImgWidth.value);
      }
      res('');
    }).then(() => {
      setTimeout(() => showHideIcons(), 600);
    });
  }
};

watch(
  () => [activeTypeItems.value, isMobile.value],
  () => {
    if (videoSliderRef.value && videoSliderRef.value[0]) {
      const videoSlider = videoSliderRef.value[0];
      if (activeTypeItems.value === 'video') {
        videoRange.value = [0, 1];
      } else {
        loadVideoForStart.value = {};
      }
      videoSlider.scrollLeft = 0;
      const additionalValueML = isMobile.value ? 10 : 14;
      firstImgWidth.value =
        videoSlider.clientWidth + additionalValueML;
      setTimeout(() => {
        if (videoSliderRef.value) {
          currentHeightUnactiveItem.value = `${videoSlider.clientHeight}px`;
          scrollWidth =
            videoSlider.scrollWidth - videoSlider.clientWidth;
        }
      }, 100);
      setTimeout(() => showHideIcons(), 600);
    }
  },
);

const resizeHandler = () => {
  currentWidth.value = window.innerWidth;
  const additionalValueML = isMobile.value ? 10 : 14;
  if (!videoSliderRef.value) return;
  const videoSlider = videoSliderRef.value[0];
  firstImgWidth.value = videoSlider.clientWidth + additionalValueML;
  currentHeightUnactiveItem.value = `${videoSlider.clientHeight}px`;
  currentHeightBlockWithActiveItem.value = `${
    videoSlider.clientHeight + (currentWidth.value < 768 ? 270 : 0)
  }px`;

  const afterSlide = autoSlide();
  if (afterSlide && afterSlide % firstImgWidth.value !== 0) {
    videoSlider.scrollLeft =
      firstImgWidth.value *
      Math.round(videoSlider.scrollLeft / firstImgWidth.value);
  }
};

onMounted(() => {
  isMount.value = true;
  if (videoSliderRef.value) {
    const videoSlider = videoSliderRef.value[0];
    const additionalValueML = isMobile.value ? 10 : 14;
    firstImgWidth.value = videoSlider.clientWidth + additionalValueML;
    window.addEventListener('resize', resizeHandler);
    scrollWidth = videoSlider.scrollWidth - videoSlider.clientWidth;
  }
  chooseActiveTypeItemsHandler('video');
  setTimeout(() => showHideIcons(), 60);
});

onUnmounted(() => {
  window.removeEventListener('resize', resizeHandler);
});
</script>

<style scoped lang="scss">
.images__wrapper {
  position: relative;
  height: fit-content;
  min-height: 55px;

  .loader__wrapper {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: -1;

    @media (max-width: $lg) {
      display: none;
    }
  }
}

.images__wrapper-video {
  position: relative;
  height: fit-content;
  min-height: 55px;

  svg {
    position: absolute;
    top: 24%;
    left: 30%;
    height: 30px;
    cursor: pointer;
  }

  .loader__wrapper {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: -1;
  }
}

.wrapper {
  position: relative;
  max-width: 100vw;
  width: 100%;
  display: flex;
  gap: $g-1;

  @media (max-width: 900px) {
    gap: 0;
  }

  .wrapper-description {
    overflow: hidden;

    &:has(.wrapper-description_unactive) {
      flex-shrink: 0;
      @media (max-width: 900px) {
        flex-shrink: 1;
      }
    }

    &:has(.wrapper-description_active) {
      flex-grow: 1;
    }

    &_active {
      position: relative;
      max-width: 924px;
      width: 100%;
      height: 700px;
      overflow: hidden;

      .carousel {
        animation: increaseWidthForActiveItem 0.3s linear;
      }

      @media (max-width: 900px) {
        height: 400px;
      }

      @media (max-width: 720px) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: auto;

        .carousel {
          animation: none;
          margin-top: 16px;
        }
      }
    }

    &_unactive {
      cursor: pointer;
      width: 64px;
      height: 700px;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 1fr;

      @media (max-width: 900px) {
        display: none;
      }

      .unactive_title {
        grid-row: 1/3;
        grid-column: 1/2;
        background: #000000a6;
        display: flex;
        justify-content: center;
        align-items: flex-start;

        span {
          top: auto;
          bottom: 12px;
          width: max-content;
          height: fit-content;
          @include headline-h3;
          transform: rotate(-90deg) translate(50%);
          color: var(--var-white-000);
          padding-bottom: 4px;

          &:hover {
            transition: all linear 0.2s;
            background: unset;
          }
        }
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: none;
        z-index: -1;
        grid-row: 1/3;
        grid-column: 1/2;
      }

      @media (max-width: 720px) {
        position: absolute;
        bottom: -16px;
        max-height: 10px;
        max-width: 10px;
        border-radius: 50%;

        img {
          display: none;
        }
      }
    }

    @media (max-width: 900px) {
      border-radius: 4px;
    }

    &:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    &_br-16 {
      &:first-child {
        border-top-left-radius: $br-6;
        border-bottom-left-radius: $br-6;
      }

      &:last-child {
        border-top-right-radius: $br-6;
        border-bottom-right-radius: $br-6;
      }
    }

    &_switch-btns {
      position: absolute;
      bottom: -72px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 16px;

      .btn-prev,
      .btn-next {
        background-color: #0081ff;
        width: 56px;
        height: 56px;
        border: none;
        outline: none;
        border-radius: 4px;
        cursor: pointer;
      }
    }
  }

  .content__count-items {
    position: absolute;
    bottom: 70px;
    right: 24px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    gap: 2px;

    @media (max-width: 720px) {
      flex-direction: row;
      bottom: 13px;
      right: unset;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .content__count-img {
    background-color: rgba(255, 255, 255, 0.2);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 1px solid #e1e5f0;
    cursor: pointer;

    &_active {
      background-color: var(--var-white-000);
    }
  }

  .content__description {
    position: absolute;
    width: 100%;
    bottom: $m-0;
    padding: $p-6 $p-12 $p-10 $p-6;
    left: $m-0;
    z-index: 100;
    background: linear-gradient(
        360deg,
        #000000 0%,
        rgba(0, 0, 0, 0.3) 78.6%,
        rgba(0, 0, 0, 0) 100%
    );

    .description__wrapper {
      display: flex;
      gap: $g-10;

      .type-btns {
        display: flex;
        flex-direction: column;
        gap: $g-2;

        svg {
          cursor: pointer;
        }
      }

      .description {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding-right: $p-2;

        p {
          color: #fff;
          margin-top: 16px;
          font-weight: 400;
          font-size: 15px;
          line-height: 21px;
          @media (max-width: 720px) {
            color: #64686e;
          }
        }
      }

      @media (max-width: 720px) {
        gap: 16px;
        margin-bottom: 20px;
      }
    }

    @media (max-width: 900px) {
      padding: $p-6 $p-10 $p-10 $p-6;
    }

    @media (max-width: 720px) {
      padding: $p-0;
      padding-bottom: $p-5;
      position: relative;
      background: unset;
      max-height: 270px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .wrapper-author {
        overflow: auto;
      }

      h3 {
        color: var(--var-black-100);
      }

      p {
        color: var(--var-black-100);
        margin-bottom: $m-5;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        line-clamp: 5;
        -webkit-box-orient: vertical;
      }
    }
  }

  & span {
    top: 50%;
    height: 44px;
    width: 44px;
    color: #343f4f;
    font-size: 1.15rem;
    position: absolute;
    text-align: center;
    line-height: 44px;
    border-radius: 50%;
    transform: translateY(-50%);
    transition: transform 0.1s linear;

    z-index: 100;

    &:active {
      transform: translateY(-50%) scale(0.9);
    }

    &:hover {
      transition: all linear 0.2s;
      background: #a2a2a2;
    }

    svg {
      height: 44px;
      width: 44px;
    }
  }

  .carousel {
    position: relative;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    scroll-behavior: smooth;

    .video {
      position: relative;
      max-height: 700px;
      background: var(--var-video-bg-video);

      @media (max-width: 720px) {
        background: transparent;
      }
    }

    .images {
      position: relative;
      background: var(--var-video-bg-video);
      max-height: 700px;

      @media (max-width: 720px) {
        min-height: 200px;
        background: transparent;
      }
    }
  }

  .dragging {
    scroll-behavior: auto;

    video::-webkit-media-controls {
      display: none; // Стандартные элементы управления отключены.
    }

    &img {
      pointer-events: none;
      cursor: grab !important;
    }
  }

  @media (max-width: 900px) {
    align-items: end;
  }

  @media (max-width: 720px) {
    flex-direction: column;
  }
}

.dragging {
  video {
    cursor: grabbing !important;
  }

  img {
    cursor: grabbing !important;
  }
}

h3 {
  font-size: 24px;
  margin: 0;
  color: var(--var-white-000);
}

p {
  @include launcher-p2;
  margin: $m-4 0px 0px 0px;
  color: var(--var-white-000);
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;

  @media (max-width: 720px) {
    margin: $m-2 0px $m-1 0px;
    -webkit-line-clamp: unset;
    line-clamp: unset;
    -webkit-box-orient: vertical;
  }
}

@keyframes increaseWidthForActiveItem {
  0% {
    width: 10%;
  }

  100% {
    width: 100%;
  }
}
</style>
